module.exports = __webpack_public_path__ + "static/media/userIcon.e3dd02fd.svg";